import styled from 'styled-components';
import { Form, FormProps } from 'antd';

interface StyledFormCheckBoxWrapperProps {
  $isMarginTop?: boolean;
  $isBoldLabel?: boolean;
}
interface StyledFormRadioGroupWrapperProps {
  $isBoldLabel?: boolean;
}

interface StyledCheckboxesWithoutGroupProps {
  $direction?: string;
  $isSub?: boolean;
}

const StyledFormMainWrapper = styled(Form)<FormProps>`
  height: 100%;
  max-width: 100%;
  .ant-form-item-label > label.ant-form-item-required::before,
  .ant-form-item-label > label::after {
    display: none;
  }

  &.ant-form {
    display: flex;
    flex-direction: column;
    color: ${(props) => props.theme.colors.primaryText};
  }

  &.ant-form-item-required {
    .hint-label p:not(:empty) {
      &:after {
        content: '*';
      }
    }
  }
  &.ant-form label {
    color: ${(props) => props.theme.colors.primaryText};
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
  }
  &.ant-form {
    .ant-mentions,
    textarea.ant-input {
      margin-bottom: 0;
    }
    .ant-input[disabled],
    .ant-select-selection[disabled],
    .ant-select-disabled .ant-select-selection {
      border-color: ${(props) => props.theme.colors.primaryBorder};
      background-color: ${(props) => props.theme.colors.grayButton};
      color: ${(props) => props.theme.colors.filterLabelColor};
      opacity: 1;
    }
    .ant-select-disabled .ant-select-selection-item {
      color: ${(props) => props.theme.colors.filterLabelColor};
    }
  }
  &.ant-form {
    .ant-input[disabled]:hover,
    .ant-select-selection[disabled]:hover,
    .ant-select-disabled:hover .ant-select-selection,
    .ant-select-disabled .ant-select-selection:hover,
    .ant-form-item-control:hover .ant-select-disabled .ant-select-selection {
      border-color: ${(props) => props.theme.colors.primaryBorder};
      background-color: ${(props) => props.theme.colors.grayButton};
      color: ${(props) => props.theme.colors.primaryText};
    }
  }
  .ant-picker-panel-container,
  .ant-picker-range-arrow::after {
    background: ${(props) => props.theme.colors.tableTrEvenColor};
  }
`;
const StyledTopWrapper = styled.div`
  margin-top: 0.4rem;
`;
const IPsFormsWrapper = styled(Form)`
  &.ant-form {
    display: flex;
    align-items: flex-end;
    > div:first-of-type {
      width: 15.4rem;
    }
    > div:last-of-type {
      width: 9.9rem;
    }
    > p {
      margin: 0 1.1rem 0.8rem;
      height: 1.14rem;
    }
  }
`;
const StyledFormCheckBoxWrapper = styled.div<StyledFormCheckBoxWrapperProps>`
  margin-top: ${(props) => (props.$isMarginTop ? '2.28rem' : '0')};
  .ant-form-item {
    .ant-form-item-label {
      font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
      margin-bottom: 1.14rem;
      font-weight: ${(props) => (props.$isBoldLabel ? props.theme.typography.fontWeightRegular : props.theme.typography.fontWeightMedium)};
      padding: 0;
    }
    .ant-form-item-label > label::after {
      display: none;
    }
  }
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
  }
  .ant-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1.71rem;
    label {
      width: auto;
      span {
        font-size: ${(props) => props.theme.typography.fontSizeDefault};
    }
  }
  .ant-radio-wrapper {
    span {
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
    }
  }
`;

const StyledFormRadioGroupWrapper = styled.div<StyledFormRadioGroupWrapperProps>`
  .ant-radio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1.71rem 0.71rem;

    .ant-radio-wrapper {
      margin-right: 0;
    }
  }
  .ant-form-item {
    .ant-form-item-label {
      font-weight: ${(props) => props.theme.typography.fontWeightMedium};
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
      margin-bottom: 1.14rem;
      font-weight: ${(props) => (props.$isBoldLabel ? props.theme.typography.fontWeightRegular : props.theme.typography.fontWeightMedium)};
      padding: 0;
    }
  }
`;

const StyledCheckboxesWithoutGroup = styled.div<StyledCheckboxesWithoutGroupProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) => (props.$direction === 'vertical' ? 'column' : 'row')};
  gap: 1.28rem 1.71rem;
  margin-left: ${(props) => (props.$isSub ? '1.71rem' : '0')};

  .ant-checkbox-wrapper {
    vertical-align: middle;
  }

  .ant-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 1.28rem 1.71rem;
  }
  strong {
    font-size: ${(props) => props.theme.typography.fontSizeDefault};
    flex-basis: 100%;
    margin-bottom: -0.2rem;
    color: ${(props) => props.theme.colors.primaryText};
  }
  label {
    width: auto;

    span {
      font-size: ${(props) => props.theme.typography.fontSizeDefault};
    }
  }
`;

const StyledDOBPickerWrapper = styled.div`
  display: flex;
  align-items: flex-end;

  > .ant-form-item {
    flex: 0 0 64%;
    max-width: 64%;

    .ant-picker.ant-picker-range {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &:first-child {
      flex: 0 0 36%;
      max-width: 36%;

      .ant-select.ant-select-single {
        border-top-left-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
        border-bottom-left-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
        border-right: none;
      }
    }

    &:last-child {
      .ant-select.ant-select-single {
        border-top-right-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
        border-bottom-right-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
        border-left: none;
        border-right-width: 1px;
      }
    }

    .ant-select.ant-select-single {
      padding: 0 0.71rem;
      border-radius: 0;
      border-right-width: 0;
      .ant-select-placeholder,
      .ant-select-content-value {
        padding-right: 0.57rem;
      }

      .ant-select-selection-search {
        width: calc(100% - 3rem);
      }
    }
  }
`;

const StyledDOBSelectWrapper = styled(StyledDOBPickerWrapper)`
  & > .ant-form-item {
    flex: 0 0 32%;
    max-width: 32%;
  }
`;

export {
  StyledFormMainWrapper,
  StyledTopWrapper,
  IPsFormsWrapper,
  StyledFormCheckBoxWrapper,
  StyledFormRadioGroupWrapper,
  StyledCheckboxesWithoutGroup,
  StyledDOBPickerWrapper,
  StyledDOBSelectWrapper,
};
